import { Course } from '../types';

export const newborn_operations_manual: Course = {
  id: "newborn_operations_manual",
  title: "Newborn Operations Manual",
  description: "A father's guide to the first few weeks. Practical strategies for surviving and thriving with a newborn.",
  icon: "🍼",
  totalModules: 9,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/newborn_operations_manual/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/newborn_operations_manual/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/newborn_operations_manual/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/newborn_operations_manual/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/newborn_operations_manual/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/newborn_operations_manual/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/newborn_operations_manual/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/newborn_operations_manual/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/newborn_operations_manual/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "Based on 'THE LOGISTICS OF NEWBORN CARE' slide, what is the specified neck opening angle for a baby grow?",
        "o": [
            "30°",
            "45°",
            "60°",
            "90°"
        ],
        "a": 1
    },
    {
        "q": "According to the 'MISSION BRIEFING AND OPERATIONAL ZONES' slide, what is the core directive for newborn care?",
        "o": [
            "Ensure timely feeding and diaper changes",
            "Achieve total mastery of the physical environment and baby safety",
            "Monitor sleep patterns and growth",
            "Maintain a sterile environment at all times"
        ],
        "a": 1
    },
    {
        "q": "In 'Zone 2 (Sleep Environment)', what is the recommended target temperature range for the baby's sleep environment?",
        "o": [
            "10-15°C",
            "16-20°C",
            "21-25°C",
            "26-30°C"
        ],
        "a": 1
    },
    {
        "q": "According to 'THE POONAMI PROTOCOL & ENVELOPE MECHANICS', how should a UK vest with envelope shoulders be removed in the event of a blowout?",
        "o": [
            "Pull upward over the head",
            "Cut the vest off with scissors",
            "Execute a downward pull over the legs",
            "Rip the vest from the shoulders"
        ],
        "a": 2
    },
    {
        "q": "Based on the 'SKIN HEALTH DIAGNOSTIC MATRIX', which product is recommended for 'Prevention (Green Zone)' when skin is healthy and unbroken?",
        "o": [
            "Sudocrem or Metanium",
            "Vaseline",
            "Prescription treatment",
            "Talcum powder"
        ],
        "a": 1
    },
    {
        "q": "What does the 'C' in the 'ABCs of Safe Sleep' stand for?",
        "o": [
            "Comfortable",
            "Cozy",
            "Clear Cot",
            "Clean"
        ],
        "a": 2
    },
    {
        "q": "When assessing an infant's core temperature using 'The Elbow Test', which body parts should be used for an accurate reading?",
        "o": [
            "Hands and feet",
            "Forehead and cheeks",
            "Chest or back of the neck",
            "Belly and thighs"
        ],
        "a": 2
    },
    {
        "q": "According to the 'FIELD OPERATIONS: THE CHANGE BAG AUDIT', what is the minimum required number of nappies in the core inventory?",
        "o": [
            "1x Nappy",
            "2x Nappies",
            "3x Nappies",
            "5x Nappies"
        ],
        "a": 2
    },
    {
        "q": "What is the maximum duration an infant should remain in a car seat, as per the 'Spinal/Airway Limit' in 'TRANSIT SAFETY AND INFRASTRUCTURE BOUNDARIES'?",
        "o": [
            "1 hour",
            "2 hours",
            "3 hours",
            "4 hours"
        ],
        "a": 1
    },
    {
        "q": "The 'DAILY OPERATIONS DASHBOARD' lists 'A.B.C.' as the Sleep Standard. What does this acronym represent?",
        "o": [
            "Always Be Cautious",
            "Alone, Back, Clear",
            "Active, Breathing, Comfortable",
            "Aware, Balanced, Calm"
        ],
        "a": 1
    }
]
};
